import * as React from "react";
import { Link } from "react-router";
import styled, { css } from "styled-components";
import { IButtonStyledProps } from "./Button";

const ButtonLinkStyles = css<IButtonStyledProps>`
  display: inline-block;
  padding: 1.5rem ${(props) => props.theme.space[3]};
  border: 0;
  font-family: ${(props) => props.theme.fonts.body};
  font-size: ${(props) => props.theme.fontSizes[1]};
  font-weight: 500;
  border-radius: ${(props) => props.theme.radii[1]};
  text-align: center;
  text-decoration: none;
  line-height: 1;
  cursor: pointer;
  text-transform: capitalize;

  ${(props) =>
    props.fullwidth &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.variant === "primary" &&
    css`
      background-color: ${(props) => props.theme.colors.secondary};
      color: ${(props) => props.theme.colors.white};
      box-shadow: inset 0 0 0 2px ${({ theme }) => theme.colors.secondary};
    `}

    ${(props) =>
    props.variant === "secondary" &&
    css`
      background-color: ${(props) => props.theme.colors.white};
      box-shadow: inset 0 0 0 2px ${({ theme }) => theme.colors.secondary};
      color: ${(props) => props.theme.colors.secondary};
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    ${(props) =>
      props.minwidth &&
      css`
        min-width: 115px;
      `}
  }
`;

const StyledButtonLink = styled(Link)<IButtonStyledProps>`
  ${ButtonLinkStyles}
`;

interface IProps {
  onClick?: () => void;
  to: string;
  children: React.ReactNode;
}

type Props = IProps & IButtonStyledProps;

const ButtonLink: React.FC<Props> = ({
  children,
  fullwidth,
  minwidth,
  onClick,
  to,
  variant,
}) => (
  <StyledButtonLink
    to={to}
    onClick={onClick}
    variant={variant}
    fullwidth={fullwidth}
    minwidth={minwidth}
  >
    {children}
  </StyledButtonLink>
);

export default ButtonLink;
